import { navLinks, categories, contactInfo } from "@/pages/home/data";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-secondary-950 text-lg">
                <i className="ri-file-shield-2-line" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                {contactInfo.brand}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/90">
              公开审核标准、发布规则与处理时长，让每一次投稿从提交到曝光都有据可依。
            </p>
            <a
              href={`mailto:${contactInfo.email}`}
              className="mt-5 inline-flex items-center gap-2 px-4 py-2 rounded-md bg-background-50 text-secondary-900 text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-send-line" aria-hidden="true"></i>
              投稿咨询
            </a>
          </div>

          <nav aria-label="站内导航">
            <h2 className="font-heading text-base font-semibold text-background-50">
              站内导航
            </h2>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-200/90 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="主题分类导航">
            <h2 className="font-heading text-base font-semibold text-background-50">
              主题分类
            </h2>
            <ul className="mt-4 space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href="#categories"
                    className="text-sm text-background-200/90 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h2 className="font-heading text-base font-semibold text-background-50">
              联系与跟进
            </h2>
            <ul className="mt-4 space-y-3 text-sm text-background-200/90">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400" aria-hidden="true"></i>
                <span className="break-all">{contactInfo.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-accent-400" aria-hidden="true"></i>
                <span>{contactInfo.replyTime}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-hashtag mt-0.5 text-accent-400" aria-hidden="true"></i>
                <span>{contactInfo.followUp}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs md:text-sm text-background-200/70">
            © {year} {contactInfo.brand} · 本页内容为平台公开规则说明，仅供参考。
          </p>
          <a
            href="#top"
            className="inline-flex items-center gap-1.5 text-xs md:text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-up-line" aria-hidden="true"></i>
            返回顶部
          </a>
        </div>
      </div>
    </footer>
  );
}